<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="docForm">
  <div class="accordion-class">
    <h5 *ngIf="!EditMode">Add Documents</h5>
    <h5 *ngIf="EditMode">Edit Documents</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Document Name:</mat-label>
          <input
            matInput
            formControlName="docName"
            style="text-transform: capitalize"
            required
          />
          <mat-error
            *ngIf="(DocFormControl['docName'].touched) && DocFormControl['docName'].errors?.['required']"
          >
            Please Enter Document Name
          </mat-error>
          <mat-error
            *ngIf="(DocFormControl['docName'].touched) && DocFormControl['docName'].errors?.['pattern']"
          >
            Please Enter Valid Document Name
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-select formControlName="module" required>
            <mat-option value="">Select Module</mat-option>
            <mat-option value="truck">Truck</mat-option>
            <mat-option value="driver">Driver</mat-option>
          </mat-select>
          <mat-error
            *ngIf="(DocFormControl['module'].touched) && DocFormControl['module'].errors?.['required']"
            >Please Select Module</mat-error
          >
        </mat-form-field>
      </div>

      <div class="mb-3 pull-left w-100 document-area">
        <span>Document Required</span>
        <mat-checkbox class="" formControlName="docRequired"></mat-checkbox>
      </div>
    </div>
  </div>

  <button
    *ngIf="!EditMode"
    type="button"
    class="button buttonBlue"
    [class.spinner]="loading"
    [disabled]="loading"
    (click)="SubmitDoc()"
  >
    Add Document
  </button>
  <button
    *ngIf="EditMode"
    type="button"
    class="button buttonBlue"
    [class.spinner]="loading"
    [disabled]="loading"
    (click)="UpdateDoc()"
  >
    Update Document
  </button>
</form>
